import {Button, CardHeader, Divider, Grid, MenuItem, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import {withStyles} from "@mui/styles";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';

export class PlayerBoobyTrapsMain extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            boobyTrapsData: [],
            userId: this.props.playerId,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchBoobyTraps = () => axios.get(`${Config.getInstance.apiUrl}/api/user/${this.state.userId}/booby_traps`, {
        headers: {
            Authorization: Helpers.getSessionId(),
            env: this.props.activeEnv,
        },
    });

    removeLayout = async (layoutId: string, mode: "ruby" | "competitive") => {
        if (confirm("Are you sure you want to remove this layout?")) {
            try {
                const response = await axios.post(`${Config.getInstance.apiUrl}/api/user/${this.state.userId}/booby_traps/remove`, {
                    layout_id: layoutId,
                    mode: mode,
                }, {
                    headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
                });
                if (response.data.success) {
                    PopupMessage.success("Layout removed!");
                } else {
                    PopupMessage.error("Layout remove failed: " + response.data.message);
                }
            } catch (error) {
                console.error("removeLayout error", error);
                PopupMessage.error("Layout remove failed: " + error.message);
            }
        }
    }


    fetchData = async () => {
        this.setState({
            loading: true,
        });

        const response = await this.fetchBoobyTraps();
        const data = response.data;

        this.setState({
            loading: false,
            boobyTrapsData: data,
        });
    }

    copyToClipboard(text: string) {
        navigator.clipboard.writeText(text);

        PopupMessage.success("Copied to clipboard");
    }

    onChangeFilter(key: string, value: any) {
        const {filter} = this.state;

        filter[key] = value;

        this.setState({filter});
    }

    onClearFilter = () => {
        const filter = {
            opponentId: '',
            type: 'All',
            stars: '',
            limit: 10,
            offset: 0,
            percent: ''
        }

        this.setState({filter});
    }

    renderOpponent = (opponent: any, opponentId: string) => {
        const user = opponent.user;
        const {name, squad_name} = user;

        return <Paper>
            <Grid container sm={12} spacing={1}>
                <Grid item container sm={10}>
                    <Grid item sm={12}>{name}</Grid>
                    <Grid item sm={12}>[{squad_name || 'No Squad'}]</Grid>
                </Grid>
                <Grid item sm={2}>
                    <ContentCopyIcon
                        onClick={() => this.copyToClipboard(JSON.stringify({
                            id: opponentId,
                            name,
                            squad: squad_name || 'No Squad'
                        }))}
                    />
                </Grid>
            </Grid>
        </Paper>
    }

    renderLayout = (layouts: any, mode: "ruby" | "competitive", redisLayoutId: string) => {
        return <Paper>
             <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell style={{width: "5%"}}>ID</TableCell>
                        <TableCell>Buildings</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        layouts?.map((layout: any, index: number) => {
                            const isRedisLayout = redisLayoutId === layout.id;
                            const color = isRedisLayout ? "green" : "red";
                            const buildings = JSON.stringify(layout.buildings);
                            return <TableRow key={index}>
                                <TableCell style={{color: color}}>{index + 1}</TableCell>
                                <TableCell style={{color: color}}>{layout.id}</TableCell>
                                
                                <TableCell>
                                    <div style={{width: '500px', overflowX: 'auto', whiteSpace: 'nowrap'}}>
                                        <ContentCopyIcon
                                                titleAccess="Copy Map Data"
                                                onClick={() => this.copyToClipboard(buildings)}
                                            />
                                        <Typography style={{color: color}}>{buildings}</Typography>
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <DeleteIcon
                                        style={{cursor: isRedisLayout ? "not-allowed" : "pointer", color: isRedisLayout ? "grey" : "red"}}
                                        titleAccess="Remove Layout"
                                        onClick={() => isRedisLayout ? null : this.removeLayout(layout.id, mode)}
                                    />
                                    <Typography style={{color: isRedisLayout ? "grey" : "red"}}>Remove Layout</Typography>
                                    
                                </TableCell>
                            </TableRow>
                        })
                    }
                </TableBody>
            </Table>
        </Paper>
    }


    renderContent() {
        if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={11}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        const boobyTrapsData = this.state.boobyTrapsData;
        const {classes} = this.props;

        return <>
            <Typography className={classes.paper} variant="h6">{`Strategic Layouts`}</Typography>
            {this.renderLayout(boobyTrapsData?.strategicLayouts || [], "ruby", boobyTrapsData?.redisLayoutId)}
            <Typography variant="h6" style={{backgroundColor: "green", color: "white"}}>{`Redis Strategic Layout: ${boobyTrapsData?.redisLayoutId}`}</Typography>

            <Divider style={{marginTop: 50, marginBottom: 50}} />
            <Typography variant="h6" className={classes.paper}>{`Competitive Layouts`}</Typography>
            {this.renderLayout(boobyTrapsData?.competitiveLayouts || [], "competitive", boobyTrapsData?.redisCompetitiveLayoutId)}
            <Typography variant="h6" style={{backgroundColor: "green", color: "white"}}>{`Redis Competitive Layout: ${boobyTrapsData?.redisCompetitiveLayoutId}`}</Typography>
        </>
    }

    render() {
        const {classes} = this.props;
        return <Paper className="contentPadding">
            <Typography className={classes.paper} variant="h6">{`Booby Traps layouts for UID: ${this.state.userId}`}</Typography>
            <Divider style={{marginTop: 10, marginBottom: 10}} />
            {this.renderContent()}
        </Paper>
    }
}

const styles: any = () => ({
    paper: {
        padding: 8,
        backgroundColor: "black"
    },
});

export const PlayerBoobyTraps = withStyles(styles)(PlayerBoobyTrapsMain);